export const STORE_THEME_STORAGE_KEY = 'theme';

export const STORE_THEME_CHANGE_EVENT = 'allegra-store-theme-change';

export function applyStoreThemeToDocument(isDark) {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
}

export function persistStoreTheme(isDark) {
  try {
    localStorage.setItem(STORE_THEME_STORAGE_KEY, isDark ? 'dark' : 'light');
  } catch (_) {
    /* ignore */
  }
  applyStoreThemeToDocument(isDark);
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(STORE_THEME_CHANGE_EVENT));
  }
}

export function readStoreThemeIsDark() {
  if (typeof localStorage === 'undefined') return true;
  const v = localStorage.getItem(STORE_THEME_STORAGE_KEY);
  if (v === 'light') return false;
  if (v === 'dark') return true;
  return true;
}

export function initializeStoreTheme() {
  const isDark = readStoreThemeIsDark();
  persistStoreTheme(isDark);
  return isDark;
}
